// Import routes
import { CONFIGURATOR_PATHS } from 'components/routes/configurator/routes';
import { MAIN_PATHS } from 'components/routes/app_routes/paths';
import { AuthPaths } from 'components/routes/auth/routes';

export const CONFIGURATOR_STEPS = [
	{ title: 'summary', path: CONFIGURATOR_PATHS.SUMMARY },
	{ title: 'payment_method', path: CONFIGURATOR_PATHS.PAYMENT_METHOD }
];

export const ALLOWED_PATHS = [AuthPaths.Registration, MAIN_PATHS.PAYMENT_VERIFICATION].concat(CONFIGURATOR_STEPS.map((step) => step.path));
